import { useCallback, useEffect, useMemo, useContext } from "react";
import throttle from "lodash/throttle";

import { sessionSocket } from "../singletons/SessionSocket";
import { Auth } from "../contexts/ridersUserContext";

export const ScreenActivity = () => {
	const {
		shutdown,
	}: any = useContext<any>(Auth.context);

	const heartbeat = useCallback(() => {
		if (shutdown) return;

		if (!sessionSocket) return;

		sessionSocket.sendHeartbeat();
	}, [shutdown]);

	const debouncedHeartbeat = useMemo(() => {
		return throttle(heartbeat, 30_000, {
			leading: true,
			trailing: false,
		});
	}, [heartbeat]);

	useEffect(() => {
		const handleActivity = () => debouncedHeartbeat();

		if (!shutdown) {
			window.addEventListener("keydown", handleActivity);
			window.addEventListener("mousedown", handleActivity);
			window.addEventListener("touchstart", handleActivity);
			window.addEventListener("wheel", handleActivity);
			window.addEventListener("pointerdown", handleActivity);
		}

		return () => {
			window.removeEventListener("keydown", handleActivity);
			window.removeEventListener("mousedown", handleActivity);
			window.removeEventListener("touchstart", handleActivity);
			window.removeEventListener("wheel", handleActivity);
			window.removeEventListener("pointerdown", handleActivity);
			debouncedHeartbeat.cancel();
		};
	}, [shutdown, debouncedHeartbeat]);

	return null;
};
